import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Checkbox } from 'antd';

import MainCategoryItem from './MainCategoryItem';
import { useExhibitCategoryCheck } from './hooks/useExhibitCategoryCheck';
import './ExhibitCategoryEditableTable.scss';

const ExhibitCategoryEditableTable = (props) => {
  const {
    onDelete,
    onDragEnd,
    exhibitCategoryDataSource,
    onSelectExhibit,
    onSelectAllExhibit,
    selectedExhibitCategoryList,
    exhibitCategoryTabType,
  } = props;

  const { allChecked, indeterminate, onCheckAll } = useExhibitCategoryCheck({
    allListCount: exhibitCategoryDataSource.reduce((prev, curr) => {
      return prev + curr.children.length + 1;
    }, 0),
    selectedCount: selectedExhibitCategoryList.length,
    onSelectAllExhibit,
    exhibitCategoryTabType,
  });

  if (!exhibitCategoryDataSource) return <></>;

  return (
    <div className="table-wrapper">
      <DndProvider backend={HTML5Backend}>
        <table className="exhibit-category-editable-table">
          <thead className="exhibit-category-editable-table-header">
            <tr>
              <th>
                <Checkbox
                  checked={allChecked}
                  onChange={(e) => onCheckAll(e.target.checked)}
                  indeterminate={indeterminate}
                />
              </th>
              <th>
                <span>순서</span>
              </th>
              <th>
                <span>카테고리명</span>
              </th>
              <th>
                <span>삭제</span>
              </th>
            </tr>
          </thead>
        </table>
        <div className="table-body-wrapper">
          <table className="exhibit-category-editable-table">
            <tbody className="exhibit-category-editable-table-box">
              {exhibitCategoryDataSource.map((mainCategory, index) => (
                <MainCategoryItem
                  key={mainCategory.id}
                  index={index}
                  order={Number(index) + 1}
                  onDelete={onDelete}
                  mainCategory={mainCategory}
                  onSelectExhibit={onSelectExhibit}
                  selectedExhibitCategoryIdList={selectedExhibitCategoryList.map((item) => item.id)}
                  onDragEnd={onDragEnd}
                />
              ))}
            </tbody>
          </table>
        </div>
      </DndProvider>
    </div>
  );
};

export default ExhibitCategoryEditableTable;
